import React, { createContext, useState, useCallback, useRef } from "react";

// [S95] UI otimista do chat: mostra a mídia/documento na hora (com relóginho)
// enquanto o envio real roda por trás (anti-ban Baileys + upload). É uma CAMADA
// SEPARADA — NÃO toca no reducer de mensagens do MessagesList. As pending são
// chaveadas pelo UUID do ticket (ticketKey) porque o MessagesList só conhece o
// uuid (useParams) e o MessageInput recebe ticket.uuid via prop. Quando a
// mensagem REAL chega pelo socket (create + fromMe + mídia), a pending some.
const OptimisticMessagesContext = createContext({
  pending: [],
  addPending: () => {},
  removePending: () => {},
  reconcilePending: () => {},
});

export const OptimisticMessagesProvider = ({ children }) => {
  const [pending, setPending] = useState([]);
  const timersRef = useRef({});

  const removePending = useCallback((tempId) => {
    setPending((prev) => prev.filter((p) => p.tempId !== tempId));
    const t = timersRef.current[tempId];
    if (t) {
      clearTimeout(t);
      delete timersRef.current[tempId];
    }
  }, []);

  const addPending = useCallback((msg) => {
    if (!msg || !msg.tempId) return;
    setPending((prev) => [...prev, msg]);
    // Safety: se a mensagem real nunca chegar (falha silenciosa do envio), a
    // pending some sozinha em 90s — nunca fica relóginho preso pra sempre.
    timersRef.current[msg.tempId] = setTimeout(() => {
      setPending((prev) => prev.filter((p) => p.tempId !== msg.tempId));
      delete timersRef.current[msg.tempId];
    }, 90000);
  }, []);

  // Remove a pending MAIS ANTIGA daquele ticket (FIFO). Chamado quando a
  // mensagem real (fromMe + mídia) chega pelo socket. Não mexe no reducer real.
  const reconcilePending = useCallback((ticketKey) => {
    setPending((prev) => {
      const idx = prev.findIndex(
        (p) => String(p.ticketKey) === String(ticketKey)
      );
      if (idx === -1) return prev;
      const removed = prev[idx];
      const t = timersRef.current[removed.tempId];
      if (t) {
        clearTimeout(t);
        delete timersRef.current[removed.tempId];
      }
      const next = prev.slice();
      next.splice(idx, 1);
      return next;
    });
  }, []);

  return (
    <OptimisticMessagesContext.Provider
      value={{ pending, addPending, removePending, reconcilePending }}
    >
      {children}
    </OptimisticMessagesContext.Provider>
  );
};

export default OptimisticMessagesContext;
